import {Modal} from "antd";
import {ConsentIntegrationOptions} from "./ConsentIntegrationSection";
import KlaviyoIntegrationForm from "./forms/KlaviyoIntegrationForm";
import FlashyIntegrationForm from "./forms/FlashyIntegrationForm";
import MailchimpIntegrationForm from "./forms/MailchimpIntegrationForm";
import useAppContext from "../../hooks/useAppContext";
import {useEffect, useState} from "react";

interface ConsentIntegrationEditModalProps {
    form: ConsentIntegrationOptions | null;
    onClose: () => void;
    isKlaviyoConnected: boolean;
    setIsKlaviyoConnected: (newVal: boolean) => void;
    isMailchimpConnected: boolean;
    setIsMailchimpConnected: (newVal: boolean) => void;
    isFlashyConnected: boolean;
    setIsFlashyConnected: (newVal: boolean) => void;
}

const ConsentIntegrationEditModal = ({ form, onClose, isKlaviyoConnected, setIsKlaviyoConnected, isMailchimpConnected, setIsMailchimpConnected, isFlashyConnected, setIsFlashyConnected }: ConsentIntegrationEditModalProps) => {
    const { data: { shop }} = useAppContext();
    const isOpen = !!form;
    const [modalWidth, setModalWidth] = useState(500);

    useEffect(() => {
        if(modalWidth === 1024 && form === null) {
            // do nothing
        } else if(form && [ConsentIntegrationOptions.KLAVIYO, ConsentIntegrationOptions.FLASHY].includes(form)) {
            setModalWidth(1024);
        } else {
            setModalWidth(500);
        }
    }, [form])

    return (
        <Modal open={isOpen} onCancel={onClose} className="consent-integration-modal" footer={null} width={modalWidth}>
            <div className="title">{form} integration</div>
            <div className="description">Connect {form} to Vuelve to automate your WhatsApp recovery and campaigns.</div>
            {form === ConsentIntegrationOptions.KLAVIYO ? <KlaviyoIntegrationForm isConnected={isKlaviyoConnected} setIsConnected={setIsKlaviyoConnected} /> : null}
            {form === ConsentIntegrationOptions.MAILCHIMP ? <MailchimpIntegrationForm onClose={onClose} isConnected={isMailchimpConnected} setIsConnected={setIsMailchimpConnected} /> : null}
            {form === ConsentIntegrationOptions.FLASHY ? <FlashyIntegrationForm onClose={onClose} isConnected={isFlashyConnected} setIsConnected={setIsFlashyConnected} /> : null}
        </Modal>
    );
}

export default ConsentIntegrationEditModal;